<template>
  <v-container grid-list-xs>
    <v-container>
      <v-card>
        <v-card-title>Perfiles</v-card-title>
        <v-card-text>
          <v-row>
            <v-col></v-col>
            <v-btn color="primary" small @click="dialogo=true">Nuevo perfil</v-btn>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table :headers="headers" :items="listaPerfil" class="elevation-1">
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editarPerfil(item)">mdi-pencil</v-icon>
                  <v-icon small @click="eliminarPerfil(item.perfilId)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogo" persistent max-width="75%">
      <v-card>
        <v-card-title>Perfil:</v-card-title>
        <v-card-text>
          <v-row>
            <!-- form: perfilId -->
            <v-col md="4">
              <v-text-field
                prepend-icon="mdi-clipboard-list"
                label="Perfil ID"
                v-model="perfil.perfilid"
                disabled
              ></v-text-field>
            </v-col>
            <!-- form: nombre -->
            <v-col md="4">
              <v-text-field
                prepend-icon="mdi-clipboard-list"
                label="Nombre"
                v-model="perfil.nombre"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title>Menu:</v-card-title>
        <v-card-text>
          <v-row>
            <!-- form: perfilmenu -->
            <v-col>
              <v-list>
                <v-list-item-group v-model="perfil.perfilMenu" multiple active-class="blue--text">
                  <template
                    v-for="(item, index) in tablalistadomenu.filter(x => x.menupadreId == 0)"
                  >
                    <v-list-item :key="item.orden" :value="item.menuId">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active" color="primary"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.nombre"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider v-if="index + 1 < tablalistadomenu.length" :key="index"></v-divider>
                    <template
                      v-for="(item, index) in tablalistadomenu.filter(x => x.menupadreId == item.menuId)"
                    >
                      <v-list-item :key="item.orden" :value="item.menuId" class="pl-10">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox :input-value="active" color="primary"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                            <v-list-item-title v-text="item.nombre"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-list-item>

                      <v-divider v-if="index + 1 < tablalistadomenu.length" :key="index"></v-divider>
                    </template>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        {{perfil}}
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="limpiarForm">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="guardarCambiosPerfil">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Perfilservice from "../../services/Perfil.service";
import Menuservice from "../../services/Menu.service";
import PerfilMenuservice from "../../services/PerfilMenu.service";
export default {
  data() {
    return {
      perfil: {
        perfilid: null,
        nombre: "",
        perfilMenu: [],
      },
      headers: [
        { text: "Id", value: "perfilId" },
        { text: "Nombre", value: "nombre" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      listaPerfil: [],
      dialogo: false,
      tablalistadomenu: [],
    };
  },
  methods: {
    cargarTablaPerfil() {
      Perfilservice.ObtenerTodo().then((res) => {
        this.listaPerfil = res.data;
      });
    },
    cargarTablaMenu() {
      Menuservice.ObtenerTodo().then((res) => {
        this.tablalistadomenu = res.data;
      });
    },
    limpiarForm() {
      this.perfil = {
        perfilid: null,
        nombre: "",
        perfilMenu: [],
      };
      this.dialogo = false;
    },
    editarPerfil(item) {
      this.perfil = {
        perfilid: item.perfilId,
        nombre: item.nombre,
        perfilMenu: item.perfilMenu,
      };
      this.dialogo = true;
    },
    async eliminarPerfil(perfilid) {
      var resp = await confirm("¿Desea eliminar el perfil?");
      if (resp) {
          Perfilservice.Eliminar(perfilid).then((res) => {
            this.cargarTablaPerfil();
          });
      }
    },
    async guardarCambiosPerfil() {
      var resp = await confirm("¿Desea guardar el perfil?");
      if (resp) {
        if (this.perfil.perfilid != null) {
          Perfilservice.Editar(this.perfil).then((res) => {
            this.limpiarForm();
            this.cargarTablaPerfil();
          });
        } else {
          Perfilservice.Insertar(this.perfil).then((res) => {
            this.limpiarForm();
            this.cargarTablaPerfil();
          });
        }
      }
    },
  },
  mounted() {
    this.cargarTablaPerfil();
    this.cargarTablaMenu();
  },
};
</script>

<style>
</style>